import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { Power } from "react-feather";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/axios";
import { isValidToken } from "../../utils/jwt";

import {
  Tooltip,
  Menu,
  MenuItem,
  IconButton as MuiIconButton,
} from "@mui/material";

import useAuth from "../../hooks/useAuth";

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
    color: black;
    font-weight: bold;
  }
`;

function NavbarUserDropdown() {
  const [anchorMenu, setAnchorMenu] = React.useState(null);

  const navigate = useNavigate();
  const { signOut } = useAuth();

  const toggleMenu = (event) => {
    setAnchorMenu(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorMenu(null);
  };

  const handleSignOut = async () => {
    await signOut();
    navigate("/auth/sign-in");
  };

  useEffect(() => {
    let token = localStorage.getItem("accessToken");

    if (!token) {
      //No token in local memory
      navigate("/auth/sign-in");
    } else {
      //Token in local memory
      if (isValidToken(token)) {
        axiosInstance.defaults.headers.common.Authorization = token;
      } else {
        navigate("/auth/sign-in");
      }
    }
  }, [navigate]);

  return (
    <React.Fragment>
      <Tooltip title="Account">
        <IconButton
          aria-owns={Boolean(anchorMenu) ? "menu-appbar" : undefined}
          aria-haspopup="true"
          onClick={toggleMenu}
          color="inherit"
          size="large"
        >
          <Power />
        </IconButton>
      </Tooltip>
      <Menu
        id="menu-appbar"
        anchorEl={anchorMenu}
        open={Boolean(anchorMenu)}
        onClose={closeMenu}
      >
        {/*<MenuItem onClick={closeMenu}>Profile</MenuItem>*/}
        <MenuItem
          onClick={handleSignOut}
          style={{
            backgroundColor: "#4a4242",
            color: "white",
            fontWeight: "bold",
          }}
        >
          Sign Out
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}

export default NavbarUserDropdown;
